import type { ReactElement } from "react";

import type { SiteMapPage, SiteMapPageSection } from "../../lib/sitemap";
import { BlockProtocolIcon } from "../icons";
import { OpenBookIcon } from "../icons/open-book-icon";

export const itemIsPage = (
  item: SiteMapPage | SiteMapPageSection,
): item is SiteMapPage => "href" in item;

export const NAVBAR_LINK_ICONS: Record<string, ReactElement> = {
  Hub: <BlockProtocolIcon sx={{ fontSize: 14 }} />,
  Docs: <OpenBookIcon sx={{ fontSize: 16 }} />,
};

export const getNavbarLinkTitle = (title: string) =>
  title === "Docs" ? "Spec" : title;

export const getNavbarLinkHref = ({
  href,
  title,
}: {
  href: string;
  title: string;
}) => (title === "Docs" ? "/spec" : href);
